module.exports = __webpack_public_path__ + "static/media/edinburgh-15.e3afd88a.jpg";